const minimumAmounts = {
    aud: 100,
    cad: 100,
    eur: 100,
    chf: 100,
    gbp: 60,
    nok: 1000,
    usd: 100,
    zar: 1500,
    idr: 1500000,
    myr: 100,
    sgd: 100
};
export const getMinimumAmount = (currency) => { var _a; return (_a = minimumAmounts[currency]) !== null && _a !== void 0 ? _a : 60; };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3VycmVuY3kuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic2VydmljZS9jdXJyZW5jeS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLGNBQWMsR0FBRztJQUNyQixHQUFHLEVBQUUsR0FBRztJQUNSLEdBQUcsRUFBRSxHQUFHO0lBQ1IsR0FBRyxFQUFFLEdBQUc7SUFDUixHQUFHLEVBQUUsR0FBRztJQUNSLEdBQUcsRUFBRSxFQUFFO0lBQ1AsR0FBRyxFQUFFLElBQUk7SUFDVCxHQUFHLEVBQUUsR0FBRztJQUNSLEdBQUcsRUFBRSxJQUFJO0lBR1QsR0FBRyxFQUFFLE9BQU87SUFDWixHQUFHLEVBQUUsR0FBRztJQUNSLEdBQUcsRUFBRSxHQUFHO0NBQ1QsQ0FBQTtBQUVELE1BQU0sQ0FBQyxNQUFNLGdCQUFnQixHQUFHLENBQUMsUUFBa0IsRUFBVSxFQUFFLFdBQUMsT0FBQSxNQUFBLGNBQWMsQ0FBQyxRQUFRLENBQUMsbUNBQUksRUFBRSxDQUFBLEVBQUEsQ0FBQSJ9